<template>
  <v-app :dark="$vuetify.theme.dark" :light="!$vuetify.theme.dark">
    <div v-if="authenticated" class="authenticated">
      <PrivateLayout />
    </div>
    <div v-else class="unauthenticated">
      <PublicLayout />
    </div>
  </v-app>
</template>

<script>
import PrivateLayout from './components/PrivateLayout'
import PublicLayout from './components/PublicLayout'

export default { 
  name: "App",
  components: {
    PrivateLayout,
    PublicLayout
  },
  data: () => ({
    themeStorageKey: "siai-theme-dark",
    drawer: null,
    navBarOptions: {
      nomeLg: "Sistema de Avaliação Institucional",
      nomeSm: "SIAI"
    }
  }),
  created() {
    const storedTheme = localStorage.getItem(this.themeStorageKey);

    if (storedTheme !== null) {
      this.$vuetify.theme.dark = storedTheme === "true";
    }
  },
  computed: {
    authenticated() {
      return this.$store.state.authenticated;
    },
  }
};
</script>
